(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template-quickshop-coffee"]) return;
  try {
    
        var elementExists = document.getElementsByClassName("product-card")
        if(elementExists.length == 0 ){
          document.getElementById("Collection").style.display = "none";
          document.getElementsByClassName("no_products_show")[0].style.display= "block";
        }
        else{
        if(window.innerWidth > 768){
          document.getElementsByClassName("collection_table_head")[0].style.display= "flex";
        }  
      }
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template-quickshop"]) return;
  try {
    
        var elementExists = document.getElementsByClassName("product-card")
        if(elementExists.length == 0 ){
          document.getElementById("Collection").style.display = "none";
          document.getElementsByClassName("no_products_show")[0].style.display= "flex";
        }
        else{
        if(window.innerWidth > 768){
          document.getElementsByClassName("collection_table_head")[0].style.display= "flex";
        }   
      }
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale_cart"] && !Shopify.designMode) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
